import { getLadderStatus } from "./ladder-progress";
export const getCompletedAwards = (
  awards,
  allCareerClimbs,
  currentUser,
  courses = [],
) => {
  return awards.filter((award) =>
    checkAwardCompletion(award, allCareerClimbs, currentUser, courses),
  );
};

export const checkAwardCompletion = (
  award,
  allCareerClimbs,
  currentUser,
  courses = [],
) => {
  const climbsForAward = getClimbsForAward(award, allCareerClimbs, courses);

  // If no climbs are required for this award, it should not be marked as complete
  if (climbsForAward.length === 0) {
    return false;
  }

  return climbsForAward.every((climbId) =>
    hasCompletedClimb(climbId, allCareerClimbs, currentUser),
  );
};

export const hasCompletedClimb = (climbId, allCareerClimbs, currentUser) => {
  const careerClimb = allCareerClimbs.find(
    (climb) => String(climb.id) === String(climbId),
  );
  const ladderProgress = currentUser.ladderProgress;
  if (!careerClimb) return false;
  if (!ladderProgress) return false;
  const ladders = careerClimb.ladders;
  return ladders.every(
    (ladder) => getLadderStatus(ladder, ladderProgress) === "COMPLETED",
  );
};

// Returns all the climb ID's that match the award type
export const getClimbsForAward = (award, allCareerClimbs, courses = []) => {
  const { awardRule } = award;
  const { requiredClimbs, requiredCourses } = award;

  switch (awardRule) {
    case "all_climbs_in_plan":
      return getAllClimbsInPlan(award.productPlan[0]?.code, allCareerClimbs);
    case "career_climb_list":
      return requiredClimbs || [];
    case "all_climbs_in_course":
      return getAllClimbsInCourses(requiredCourses, courses);
    default:
      console.error("Unknown award rule ", awardRule);
      return [];
  }
};

const getAllClimbsInCourses = (courseIds, courses) => {
  if (
    !courseIds ||
    courseIds.length === 0 ||
    !courses ||
    courses.length === 0
  ) {
    return [];
  }

  return courseIds.flatMap((courseId) => {
    const course = courses.find((c) => String(c.id) === String(courseId));
    if (!course || !course.climbs) return [];
    return course.climbs.map((climb) => climb.id).filter(Boolean);
  });
};

const getAllClimbsInPlan = (planCode, allCareerClimbs) => {
  return allCareerClimbs
    .filter((climb) => climb.productPlan.some((p) => p.code === planCode))
    .map((climb) => climb.id);
};
